/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:26:04
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Escolha o modelo do dispositivo",
    name2: "Descrição da falha:",
    name3: "Toque para seleccionar a loja de assistência",
    name4: "Loja da assistência:",
    name5: "Tempo de reserva:",
    name6: "Descreva detalhadamente o problema do seu dispositivo!",
    name7: "Toque para seleccionar a hora de chegada",
    name8: "Insira os detalhes correctos do seu contacto de modo a podermos contactá-lo",
    name9: "A hora de reserva disponível é como se indica",
    name10: "Mangyaring ipasok ang numero ng iyong telepono",
    name11: "Preço",
    name12: "Informações pessoais:",
    name13: "Por favor, insira seu nome",
    name14: "Submeter",
    name15: "Cancelar",
    name16: "OK",
  },
  shops: {
    name1: "Baseado na marca que escolheu, pode ser atendido nas seguintes lojas!",
    name2: "Brevemente em mais lojas! Fique connosco!",
  },
  price: {
    name1: "Marca",
    name2: "Modelo",
    name3: "ITEM",
    name4: "Preço",
    name5: "Lembrete amigável:",
    name6: "Estes preços são apenas para referência e o preço actual está sujeito ao estado do seu dispositivo.",
    name7: "Se não existir qualquer símbolo especial, a unidade do preço é a unidade de moeda local.",
    name8: "Lamentamos! Não existe informação de preço disponível na região actual.",
    name11:"Custo de Mão de Obra",
    name12:"Preço Total",
    name13: "5. Se o custo da mão de obra for \"/\", significa que o custo da mão de obra precisa de ser consultado com a loja.",
    item_main_board: "Placa principal",
    item_screen_frame: "Ecrã (Moldura)",
    item_screen_screen_frame: "Ecrã Secundário (Moldura)",
    item_touch_screen: "Ecrã tátil",
    item_camera: "\"Câmara\"",
    item_fixed_focus_camera: "Câmera de Foco Fixo",
    item_auto_focus_camera: "Câmera de Foco Automático",
    item_screen: "Ecrã",
    item_secondary_screen: "Tela Secundária",
    item_fingerprint_module: "Módulo de Impressão Digital",
    item_speaker: "Altifalante",
    item_receiver: "Receptor",
    item_small_board: "Pequena Placa",
    item_battery_cover: "Tampa da Bateria",
    item_battery: "Bateria",
    item_charger: "Carregador",
    item_usb_cable: "Cabo USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Sem dados",
    name2: "Fornecedor de serviço:",
    name3: "Marca do serviço:",
    name4: "Telefone:",
    name5: "Quantidade da encomenda:",
    name6: "Classificação da assistência",
    name7: "Ambiente da assistência:",
    name8: "Atitude da assistência:",
    name9: "Eficiência da assistência:",
    name10: "Qualidade da assistência:",
    name11: "Avaliação do cliente",
    name12:"para",
    name13:"Fechado",
    name14:"Address:",
  },
  reserSuccess: {
    // name1:
    //   "Abrir o Carlcare",
    name1: "Faça a captura de ecrã da informação da reserva e guarde-o como um recibo para aceder ao serviço prioritário.",
    name2: "Submetido com sucesso",
    name3: "1. Limpar dados",
    name4: "Faça antecipadamente cópia de segurança dos dados privados no seu telefone",
    name5: "2. Desactivar a palavra-passe de activação",
    name6: "Antes de se dirigir à loja, deve:",
    name7: "Loja da assistência:",
    name8: "Tempo de reserva:",
    name9: "Descrição da falha:",
    name10: "Modelo do dispositivo:",
    name11: "Número do pedido：",
    name12: "Informação da encomenda",
  },
  title: {
    
    name1: "Suporta os seguintes países:",
    name2: "Escolha o modelo",
    name3: "Reserva",
    name4: "Detalhes da loja de assistência",
    name5: "Seleccionar a loja de assistência",
  },
  error: {
    
    name1: "Sem dados. Deve verificar a sua informação da reparação",
    name2: "Necessita de mais ajuda? Por favor, contacte-nos.",
    name3: "Lamentamos, não existe um centro Carlcare na região actual.",
    name4: "Escolha primeiro um centro de serviço",
    name5: "Falha",
    name6: "Escolha primeiro o modelo do dispositivo",
    name7: "Detalhes",
    name8: "Descreva detalhadamente as suas necessidades",
    name9: "",
  },
  add1:{
    "name0": "pt-rPT",
    "name1": "Sua encomenda foi confirmada. Estamos ansiosos para sua chegada.",
    "name2": "Selecioná-lo da cidade",
    "name3": "Por favor introduza um número de telemóvel com %1$s dígitos.",
    "name4": "Horários do Dia Útil",
    "name5": "Segunda-feira",
    "name6": "Terça-feira",
    "name7": "Quarta-feira",
    "name8": "Quinta-feira",
    "name9": "Sexta-feira",
    "name10": "Sábado",
    "name11": "Domingo",
    "name12": "Introduzir país e pesquisar"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Outros",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Toque para Redirecionar",
    name3:"Abra a aplicação Carlcare para avaliar a encomenda",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Seleccionar Serviço",
    name7:"Limpeza Gratuita",
    name8:"Atualização de software",
  },
  cancelorder:{
    "cancelReason0": "Informação incorrecta",
    "cancelReason1": "Não pode chegar a tempo",
    "cancelReason2": "Pedido duplicado/Não é o meu pedido",
    "cancelReason3": "A falha não é repetida",
    "cancelReason4": "Apenas para teste/inquérito/evento/…",
    "cancelReason5": "Preço alto",
    "cancelReason6": "Falta de material",
    "cancelReason7": "Sem serviços diferenciados",
    "cancelReason8": "A loja é muito longe",
    "cancelReason9": "A loja está fechada",
    "cancelReason10": "Má atitude de serviço",
    "cancelReason11": "Substituição/reparação para outras marcas",
    "cancelReason12": "Não é possível encontrar a loja",
    "cancelReason13": "Outros",
    "cancelOrder": "Cancelar a encomenda",
    "reason_dialog_title": "Diga-nos a razão de cancelamento",
    "Cancel": "Cancelar",
    "OK": "OK",
    "name1": "Digite o código de verificação",
    "name2": "Código de verificação inválido",
    "repair_reservation_detail_canceled": "Esta encomenda foi cancelada!",
    "purchase_cancel_dialog_content": "Confirma o cancelamento da encomenda?",
    "yes": "\"Sim\"",
    "no": "Não"
}
};
